/** @format */

import ReactDOMServer from 'react-dom/server';
import ShapeSvg from 'frontier/components/die_template/shape_svg';
import CartonSvg from 'frontier/components/die_template/carton_svg';
import React from 'react';
import {SHAPE_CARTON_AUTOLOCK, SHAPE_CARTON_STRAIGHT_TUCK} from 'frontier-constants';

export default function useDownload(props) {
    const {width, length, depth, formData} = props;

    const isCarton =
        props.shapeId === SHAPE_CARTON_STRAIGHT_TUCK || props.shapeId === SHAPE_CARTON_AUTOLOCK;
    function downloadSvg() {
        const svgString = ReactDOMServer.renderToString(<ShapeSvg {...props} />);
        const encodedData = window.btoa(svgString);
        const a = document.createElement('a');
        const e = new MouseEvent('click');
        a.download = `${width}x${length}.svg`;
        if (isCarton) {
            a.download = `${length}x${width}x${depth}.svg`;
        }
        a.href = 'data:image/svg+xml;base64,' + encodedData;
        a.dispatchEvent(e);
    }

    function downloadDxf() {
        const dxfString = CartonSvg({
            isGettingCreaseDXF: true,
            ...props
        });
        const encodedData = window.btoa(dxfString);
        const a = document.createElement('a');
        const e = new MouseEvent('click');
        a.download = `${width}x${length}x${depth}.dxf`;
        a.href = 'data:application/dxf;base64,' + encodedData;
        a.dispatchEvent(e);
    }

    return {downloadSvg, downloadDxf};
}
